import { Page } from '@/core/architecture'

import { PrepaidPointChargeTemplate } from './template'
import { useViewModel } from './viewModel'

export const PrepaidPointCharge: Page = () => {
  const { state, actions } = useViewModel()

  return <PrepaidPointChargeTemplate state={state} {...actions} />
}
